import cloneDeep from 'lodash/cloneDeep'
import { convertDashboardCardFiltersToAQL } from '../dashboardCardFiltersToAQL'
import { convertAQLToDashboardCardFilters } from '../aqlToDashboardCardFilters'
import type { DashboardCardConfig } from '../../types'

/** If the AQL changed, update the filters or if any filter changed, update the AQL */
export const syncAqlAndFormValues = (
    postValidationValues: DashboardCardConfig,
    names?: string[],
): DashboardCardConfig => {
    if (!names?.length) {
        return cloneDeep(postValidationValues)
    }

    // Only update filters from AQL if the only changed field is the AQL field
    // Why? StartLabelRangeStack changes were triggering changes to multiple fields including AQL.
    // Possibly fixed already from an order of operations issue, but it may be elsewhere.
    // Thus, checking for `names` matching exactly `['aql']`
    if (JSON.stringify(names) === '["aql"]') {
        const updatedFilters = convertAQLToDashboardCardFilters(postValidationValues.aql)
        return cloneDeep({ ...postValidationValues, filters: updatedFilters })
    }

    const updatedAQL = convertDashboardCardFiltersToAQL(postValidationValues.filters, postValidationValues.aql)

    return cloneDeep({ ...postValidationValues, aql: updatedAQL })
}

export default syncAqlAndFormValues
